import styled from "styled-components";

import { TabbedDropdown } from "@similarweb/ui-components";

import {
    StyledDDContainer,
    StyledDDContent,
} from "app/pages/sales-intelligence/sub-modules/advanced-search/components/filters/WebsiteTechnologyFilter/TechnologiesTabbedDropdownContainer/styles";

export const VERTICAL_OFFSET = "42px";
export const DROPDOWN_HEIGHT = 170;

export const StyledTechnologiesDropdown = styled(TabbedDropdown)`
    &${StyledDDContainer} {
        min-width: 0;
    }

    ${StyledDDContent} {
        top: 42px;
        width: fit-content;
        height: 280px;

        [role="tabpanel"] > div {
            height: 170px !important;
        }
    }
`;
